import { useCloudComputingPower } from 'store/src/stores/use-cloud-computing-power'
import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/97/favicon.png'
import bannerRight from '../../assets/image/97/home/banner-right.png'
import downloadBg from '../../assets/image/97/home/support-platform/download-bg.png'
import { default as logo, default as simpleLogo } from '../../assets/image/97/logo.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

const primary = '#f7b239'
const lightPrimary = '#f7b239'
const secondaryPrimary = '#F7B239'
const tertiaryPrimary = '#8B1A1A'

export const E97CreditDarkConfig: PlatformConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'dark',
  logo: logo,
  simpleLogo,
  footerLogo: logo,
  logoWidth: 32,
  footerLogoWidth: 56,
  platformName: import.meta.env.VITE_PLATFORM_NAME,
  loginShowDownload: true,
  colors: {
    hoverPrimary: '#fff',
    lightPrimary: lightPrimary,
    zero: '#424242',
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    link: '#4B5BE7',
    text: {
      base: '#FFFFFF',
      reverse: '#151519',
      primaryAlt: '#D3D4DB',
      secondary: '#A0A3A7',
      tertiary: '#6A6C75',
      quaternary: '#75777A',
      hover: '#FFFFFF',
    },
    bg: {
      base: '#151519',
      reverse: '#ffffff',
      secondary: '#1E1E24',
      hover: '#EAECEF0C',
      tertiary: '#292930',
      icon: {
        primary: '#EAECEF',
        secondary: '#A0A3A7',
        trigger: '#16161A',
        quaternary: '#A0A3A7',
      },
      button: {
        base: primary,
        primary: primary,
        aux: '#23242A',
        disabled: '#A0A0A0',
        primaryTextColor: '#151519',
      },
      tag: {
        base: '#2B2C35',
      },
      form: {
        base: '#1F2023',
        input: '#1F2023',
        modal: '#2C2C2C',
        card: '#23242A',
      },
      mainPage: {
        base: '#16161A',
        card: '#23242A',
        actionBar: '#2B2C35',
      },
      modal: {
        base: '#252525',
        card: '#23242A',
        shadow: 'rgba(0, 0, 0, 0.10)',
      },
    },
    tip: '#2C2C2C',
    cardBorder: '#4B4D5E',
    divider: '#26272D',
    borderSelected: '#A0A3A7',
    sliderMenu: '#2C2C2C',
  },
  ico,
  header: {
    boxShadow: 'none',
    background: '#16161A',
    color: '#fff',
    // boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    aColor: '#fff',
    regBtnBgColor: '#f7b239', // 注册按钮背景
    regTextColor: '#10151F', // 注册按钮文字颜色
    downloadTextColor: '#fff',
    activeColor: '#fff',
  },
  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },
  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  cloud: {
    colors: {
      bg: {
        card: {
          primary: '#2B2C35',
          fontColor: '#fff',
        },
      },
    },
  },
} as BaseConfigSource as PlatformConfig)
